import { render } from "./DeleteElementForm.vue?vue&type=template&id=23335ddc"
import script from "./DeleteElementForm.vue?vue&type=script&lang=js"
export * from "./DeleteElementForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__